import React, { useEffect, useState } from "react";
import Info from "../Assets/images/info.png";
import "../Assets/styles/newStyles/Configuration.css";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: '#cc5b02',
    color: 'white',
    boxShadow: theme.shadows[1],
    fontSize: 10,
  },
  arrow: {
    color: '#cc5b02',
  },
}));

export const Configuration = (props) => {

  const classes = useStyles();

  const {
    assessment_link,
    export_data,
    symptoms,
    vitals,
    feedback,
    assessment_limit,
    exportType,
    report_level,
    updatedConfigFunction,
  } = props;

  const options = [
    {
      label: "Allow Remote Assessments",
      value: "assessment_link",
      defaultChecked: assessment_link,
      tooltip: "Enables a link for users to access and complete the assessment online"
    },
    {
      label: "Allow Data Export",
      value: "export_data",
      defaultChecked: export_data,
      tooltip: "Grants permission to generate and download assessment details as an Excel report"
    },
    {
      label: "Collect Symptoms",
      value: "symptoms",
      defaultChecked: symptoms,
      tooltip: "Gathers information on symptoms during the assessment process"
    },
    {
      label: "Collect Vitals",
      value: "vitals",
      defaultChecked: vitals,
      tooltip: "Records vital signs during the assessment process"
    },
    {
      label: "Allow Feedback",
      value: "feedback",
      defaultChecked: feedback,
      tooltip: "Provides an option for users to give feedback on the result screen"
    },
  ];

  const [count, setCount] = useState(Number(assessment_limit));
  const [exportTypeOption, setExportType] = useState(exportType);
  const [report, setReport] = useState(report_level);

  const [radioData, setRadioData] = useState(
    options.reduce(
      (acc, option) => ({ ...acc, [option.value]: option.defaultChecked }),
      {}
    )
  );

  const handleChange = (event) => {
    const value = event.target.value === "true";
    setRadioData({ ...radioData, [event.target.name]: value });
  };

  useEffect(() => {
    updatedConfigFunction({
      ...radioData,
      assessment_limit: count,
      exportType: exportTypeOption,
      report_level: report,
    });
  }, [radioData, count, exportTypeOption, report]);

  const increaseAssessments = () => {
    setCount(count + 1);
  };

  const decreaseAssessments = () => {
    if (count <= 0) {
      setCount(0);
    } else setCount(count - 1);
  };
 
  useEffect(() => {
    if (!radioData?.assessment_link) {
      setCount(0);
    }
  }, [radioData?.assessment_link]);
 

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div className="radio-buttons-container">
          {options.map((option) => (
            <div key={option.value} className="radio-button-container">
              <div style={{ width: "280px", height: "36px" }}>
                <span className="radio-para">{option.label}</span>
                <Tooltip title={option.tooltip} classes={{ tooltip: classes.tooltip, arrow: classes.arrow }} arrow>
                  <img
                    src={Info}
                    className="info-icon-configuration"
                    alt="info"
                  />
                </Tooltip>
              </div>

              <div className="radio-input-container">
                <input
                  className="custom-radio"
                  type="radio"
                  name={option.value}
                  value="true"
                  checked={radioData[option.value]}
                  onChange={handleChange}
                  disabled
                  style={{cursor: "not-allowed"}}
                />
                <label className="radio-label">Yes</label>
              </div>
              <div className="radio-input-container">
                <input
                  type="radio"
                  className="custom-radio"
                  name={option.value}
                  value="false"
                  checked={!radioData[option.value]}
                  onChange={handleChange}
                  disabled
                  style={{cursor: "not-allowed"}}
                />
                <label className="radio-label">No</label>
              </div>
            </div>
          ))}
        </div>
        <div className="vertical-line-configuration"></div>
        <div className="select-options-container">
          {radioData?.assessment_link ? (
            <div className="select-button-container">
              <p className="select-para">Assessments Limit</p>
              <div className="assessments-count-container">
                <p
                  style={{ color: "#FF7D00", cursor: "not-allowed" }}
                  // onClick={decreaseAssessments}
                  // disabled={!radioData?.assessment_link}
                  disabled="disabled"
                >
                  -
                </p>
                <input
                  type="num"
                  className="assessment-count-select"
                  value={count < 10 ? `0${count}` : count}
                  disabled
                />
                <p
                  style={{ color: "#FF7D00", cursor: "not-allowed" }}
                  // onClick={increaseAssessments}
                  // disabled={!radioData?.assessment_link}
                  disabled="disabled"
                >
                  +
                </p>
              </div>
            </div>
          ) : (
            <div className="select-button-container disabled">
              <p className="select-para">Assessments Count</p>
              <div className="assessments-count-container disabled">
                <input
                  type="num"
                  className="assessment-count-select"
                  style={{ marginLeft: "100px", backgroundColor: "white" }}
                  disabled
                  value="00"
                />
              </div>
            </div>
          )}

          <div className="select-button-container">
            <label htmlFor="exportTypeOptions" className="select-para">
              Export Type
            </label>
            <select
              id="exportTypeOptions"
              className="assessments-count-container"
              value={exportTypeOption}
              onChange={(e) => setExportType(e.target.value)}
              disabled
            >
              <option value="apollo">Apollo</option>
              <option value="full">Full</option>
              <option value="basic">Basic</option>
            </select>
          </div>
          <div className="select-button-container">
            <label htmlFor="reportOptions" className="select-para">
              Report
            </label>
            <select
              id="reportOptions"
              className="assessments-count-container"
              value={report}
              onChange={(e) => setReport(e.target.value)}
              disabled
            >
              <option value="basic">Basic</option>
              <option value="old_default">Default</option>
              <option value="summary">Summary</option>
              <option value="detailed">Detailed</option>
              <option value="advanced">Advanced</option>
              <option value="advReport">AdvReport</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};
